import React from 'react';
import { Provider } from 'react-redux';
import { HistoryRouter as ReactRouter } from 'redux-first-history/rr6';
import { store, history } from 'store/store';
import SentryWrapper from './SentryWrapper';
const Router = ({ children }) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(ReactRouter, { history: history },
            React.createElement(SentryWrapper, null, children))));
};
export default Router;
